import { render, staticRenderFns } from "./splitpane.vue?vue&type=template&id=4852085f&scoped=true"
import script from "./splitpane.vue?vue&type=script&lang=js"
export * from "./splitpane.vue?vue&type=script&lang=js"
import style0 from "./splitpane.vue?vue&type=style&index=0&id=4852085f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852085f",
  null
  
)

export default component.exports